const vapetocart = {
    id: 'vapetocart',
    publicSiteName: 'Vape to Cart',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#b80100',
            secondary: '#000000',
            color1: '#1d791d',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapetocart/favicon.ico',
        logo: '/vapetocart/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapetocart